export default {
  createShift: '/shift/createShift',
  getShift: '/shift/getShift',
  getShiftOfInstitute: '/shift/getShiftOfInstitute',
  getShifts: '/shift/getShifts',
  getShiftNames: '/shift/getShiftNames',
  getShiftName: '/shift/getShiftName',
  updateShiftName: '/shift/updateShiftName',
  updateWorkingDays: '/shift/updateWorkingDays',
  updateShiftDetails: '/shift/updateShiftDetails',
  updateTimeSlots: '/shift/updateTimeSlots',
  deleteShift: '/shift/deleteShift'
}
